export default `${
    process.env.baseUrl
}/customer/account/google`;
